import React from 'react';
import {observer} from 'mobx-react';
import {TopImageComponent} from '../top-image/top-image.component';
import {LobbyHeaderComponent} from '../lobby-header/lobby-header.component';
import {IStickyHandler} from '../sticky-handler/sticky-handler.interface';
import {RoutedComponent} from '../base-components/routed-component/routed.component';
import {TippingHistoryPageBox} from './boxes/tipping-history-page/tipping-history-page.box';
import {TippingHistoryComponent} from './tipping-history.component';
import {ITippingHistoryViewModel} from '../../services/tipping-history/models/tipping-history-view-model.interface';

interface TippingHistoryPageComponentProps {
    redirectHomeIfUnauthorized: boolean;
}


export const TippingHistoryPageComponent = observer(
    class TippingHistoryPageComponent extends RoutedComponent<TippingHistoryPageComponentProps> {

        private _stickyHandler: IStickyHandler;
        private get stickyHandler(): IStickyHandler {
            if (!this._stickyHandler) {
                this._stickyHandler = this.services.stickyHandlerFactory.createStickyHandler();
            }

            return this._stickyHandler;
        }

        private _viewModel: ITippingHistoryViewModel = this.services.tippingHistory.getTippingHistory();

        componentWillUnmount() {
            super.componentWillUnmount();
            this.stickyHandler.dispose();
        }

        render() {
            if(!this.services.user.isAuthorized) {
                if (this.props.redirectHomeIfUnauthorized) {
                    this.services.location.goHome();
                }
                return null;
            }

            let historyTippingPageConfig = this.services.configuration.data.historyTippingPage;
            if (!historyTippingPageConfig || !this._viewModel) {
                return null;
            }

            return (
                <>
                    <TopImageComponent image={historyTippingPageConfig.topImage}/>
                    <LobbyHeaderComponent
                        title={historyTippingPageConfig.title}
                        stickyHandler={this.stickyHandler}
                        showSearchIcon={false}
                    />
                    <TippingHistoryPageBox>
                        <TippingHistoryComponent viewModel={this._viewModel}/>
                    </TippingHistoryPageBox>
                </>
            )
        }
    }
);